export default "__VITE_ASSET__CWKk_LGI__"